module.exports = __webpack_public_path__ + "img/jpyc11.fbb2bfab.png";